import React from "react";

export default function Page_2() {
    return(
        <div>
            Page 2
        </div>
    )
}